export class IdopteCheckerMessages {
  public downloadDEB = 'idopte_checker.download_deb';
  public downloadDMG = 'idopte_checker.download_dmg';
  public downloadEXE = 'idopte_checker.download_exe';
  public idopte = 'idopte_checker.idopte';
  public prerequis1 = 'idopte_checker.prerequis1';
  public prerequis2 = 'idopte_checker.prerequis2';
  public prerequis3 = 'idopte_checker.prerequis3';
  public prerequis4 = 'idopte_checker.prerequis4';
  public url = 'idopte_checker.url';
  public urlTitle = 'idopte_checker.urlTitle';
  public isPresent1 = 'idopte_checker.isPresent1';
  public isPresent2 = 'idopte_checker.isPresent2';
  public isNotPresent1 = 'idopte_checker.isNotPresent1';
  public isNotPresent2 = 'idopte_checker.isNotPresent2';

  constructor() {
  }
}
